import { v4 as uuidv4 } from 'uuid';
import { UISettingsPluginView } from './UISettingsPluginView';
import UISettingsPluginSettings from './UISettingsPluginSettings';
import i18n from '../../../i18n';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const UISettingsTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.uiSettings'),
        view: {
            content: UISettingsPluginSettings
                ? <UISettingsPluginView
                    gridId={uuidv4()}
                    plugin={UISettingsPluginSettings}
                />
                : <p> {t('general.directoryNotConfigured')} </p>
        }
    }
}

export default UISettingsTab